import React, { useMemo, useState } from 'react';
import omit from 'lodash/omit';
import { useDispatch, useSelector } from 'react-redux';
import { SpinnerLoader } from '@yme/atoms/spinner-loader';
import { fieldsToExcludeFromConsent } from '@yme/common/constants';
import { initialPrivacyConsent } from '@yme/components/PrivacyConsent/redux/actions';
import { getPrivacyConsentState } from '@yme/components/PrivacyConsent/redux/selectors';
import { setIsNotifyMeLoaded, getIsNotifyMeLoaded } from '@yme/pdp-components/ProductCard';
import { getRootLang } from '@yme/selectors/common';
import { getFormattedLanguageRootForProductRelease } from '@yme/utils/common';
import { convertConsentsPayload } from '@yme/utils/convertConsentsPayload';
import { ResponseModalWindows } from '../ResponseModalWindows';
import { FAILED_TYPE, INPUT_TYPE, NOTIFY_ME_VARIANTS, SET_DATA_INITIAL_STATE, SUCCESS_TYPE, } from '../constants';
import { setProductReleaseNotification } from '../services';
import { MiniButtonStyled } from '../styled';
import { NotifyMeProductReleaseModal } from './NotifyMeProductReleaseModal';
export function NotifyMeProductReleaseButton({ isRightToLeft, labels, productCampaignIDAttribute, privacyConsentsModel, }) {
    const [stateForm, setStateForm] = useState(null);
    const [formData, setFormData] = useState(SET_DATA_INITIAL_STATE);
    const [isActive, setIsActive] = useState(false);
    const isLoading = useSelector(getIsNotifyMeLoaded);
    const rootLanguage = useSelector(getRootLang);
    const privacyConsentState = useSelector(getPrivacyConsentState);
    const formattedRootLanguage = getFormattedLanguageRootForProductRelease(rootLanguage);
    const dispatch = useDispatch();
    const payload = useMemo(() => ({
        firstName: formData.firstName.trim(),
        lastName: formData.lastName.trim(),
        phoneNumber: formData.phoneNumber,
        email: formData?.email?.toLowerCase(),
        campaignId: productCampaignIDAttribute,
        language: formattedRootLanguage,
        privacyConsents: convertConsentsPayload(omit(privacyConsentState, fieldsToExcludeFromConsent)),
    }), [
        formData.firstName,
        formData.lastName,
        formData.phoneNumber,
        formData?.email,
        productCampaignIDAttribute,
        formattedRootLanguage,
        privacyConsentState,
    ]);
    const { notifyMeGetNotifiedLink } = labels;
    const onSwitchType = (type) => {
        setIsActive(true);
        setStateForm(type);
    };
    const onSubmitActionHandler = () => {
        dispatch(setIsNotifyMeLoaded(true));
        setProductReleaseNotification(payload, onSwitchType, dispatch);
    };
    const onHideModal = () => {
        setStateForm(null);
        dispatch(initialPrivacyConsent());
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(SpinnerLoader, { isLoading: isLoading, fullWidth: true }),
        React.createElement(MiniButtonStyled, { onClick: () => onSwitchType(INPUT_TYPE), isUnderlined: true, contentColor: "inherit" }, notifyMeGetNotifiedLink),
        stateForm === INPUT_TYPE && (React.createElement(NotifyMeProductReleaseModal, { labels: labels, privacyConsentsModel: privacyConsentsModel, onHideModal: onHideModal, onSubmitAction: onSubmitActionHandler, isRightToLeft: isRightToLeft, setFormData: setFormData, isActive: isActive, setIsActive: setIsActive })),
        (stateForm === SUCCESS_TYPE || stateForm === FAILED_TYPE) && (React.createElement(ResponseModalWindows, { labels: labels, emailText: formData?.email, isSuccessStatus: stateForm === SUCCESS_TYPE, onHideModal: onHideModal, isRightToLeft: isRightToLeft, notifyMeType: NOTIFY_ME_VARIANTS.productReleaseAnnouncement }))));
}
